import { Suspense, useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Layout from './components/Layout/';
import { ProtectedRoute } from './components/Shared/Auth/ProtectedRoute';
import Loader from './components/Shared/Loader';
import { publicRoutes, protectedRoutes } from './routes';

export default function App() {
  const navigate = useNavigate();

  useEffect(() => {
    const onLogout = () => navigate('/', { replace: true });
    window.addEventListener('auth:logout', onLogout);
    return () => window.removeEventListener('auth:logout', onLogout);
  }, [navigate]);

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {publicRoutes.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}

        {protectedRoutes.map(({ path, Component, withLayout }) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute>
                {withLayout ? (
                  <Layout>
                    <Component />
                  </Layout>
                ) : (
                  <Component />
                )}
              </ProtectedRoute>
            }
          />
        ))}
      </Routes>
    </Suspense>
  );
}
